import React from 'react';
import MobileFilterAutocomplete from './MobileFilterAutocomplete';

export default function MobileProductChoice({ label, options, value, onChange }) {
  return (
    <MobileFilterAutocomplete
      label={label}
      options={options}
      value={[value ?? '']}
      onChange={next => onChange(next[0] ?? '')}
      multiple={false}
      placeholder='Пошук у списку'
    />
  );
}
